import { Installation } from "../Installation";
import { WebSocketMetric } from "./WebSocketMetric";

export class InstallationWebSocketMetric extends Installation {
    metrics: Array<WebSocketMetric> = null;
    totalByteSent: number = 0;
    totalByteReceived: number = 0;

    constructor() {
        super();
    }

    public parse(obj: any) {
        super.parse(obj);
        if (obj.Metrics) {
            this.metrics = new Array<WebSocketMetric>();
            obj.Metrics.forEach((metric) => {
                let wsMetric = new WebSocketMetric();
                wsMetric.parse(metric);
                this.metrics.push(wsMetric);
            });
        }
        if (obj.TotalByteSent) this.totalByteSent = obj.TotalByteSent;
        if (obj.TotalByteReceived) this.totalByteReceived = obj.TotalByteReceived;
    }
}
